import { useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import {
  CapacityInboundTariffTable,
  CapacityPstnTariffTable,
  MeteredInboundTariffTable,
  MeteredPstnTariffTable,
  OutboundPrefixesTable,
  OutboundTariffTable,
  PricelistTable,
  SharedCostTariffTable,
  TollfreeTariffTable,
} from '@components/Product/Pricelists';
import { PAYMENT_MODEL } from '@config/const';
import { Page500 } from '@containers/ErrorPages';
import { productApi } from '@reducers/product/product';

const tariffActions = {
  [PAYMENT_MODEL.CAPACITY]: {
    tariff: { tableClass: CapacityInboundTariffTable },
    pstn_tariff: { tableClass: CapacityPstnTariffTable },
    tollfree_tariff: { tableClass: TollfreeTariffTable },
    sharedcost_tariff: { tableClass: SharedCostTariffTable },
    uifn_tariff: { tableClass: SharedCostTariffTable },
    outbound_tariff: { tableClass: OutboundTariffTable },
    'outbound-prefixes': { tableClass: OutboundPrefixesTable },
  },
  [PAYMENT_MODEL.METERED]: {
    tariff: { tableClass: MeteredInboundTariffTable },
    pstn_tariff: { tableClass: MeteredPstnTariffTable },
    tollfree_tariff: { tableClass: TollfreeTariffTable },
    sharedcost_tariff: { tableClass: SharedCostTariffTable },
    uifn_tariff: { tableClass: SharedCostTariffTable },
    outbound_tariff: { tableClass: OutboundTariffTable },
    'outbound-prefixes': { tableClass: OutboundPrefixesTable },
  },
};

const PricelistTableObject = ({ tariff, paymentModel, location }) => {
  const { data, isLoading, isFetching, isError } =
    productApi.useGetPricelistDataQuery({
      location,
    });
  if (isLoading || isFetching) {
    return <DefaultSpinnerCenter />;
  }
  if (isError) {
    return <Page500 />;
  }
  function getTableClass() {
    return tariffActions[paymentModel][tariff].tableClass;
  }
  const InnerTable = () =>
    getTableClass()({
      data,
      isLoading,
    });
  return <InnerTable />;
};

export const Pricelists = () => {
  const { payment_model: paymentModel } = useSelector(
    (state) => state.auth.user
  );
  const [tariff, setTariff] = useState(null);
  const [pricelistLocation, setPricelistLocation] = useState(null);
  const { data, isLoading, isError } = productApi.useGetPricelistsQuery();
  if (isLoading) {
    return <DefaultSpinnerCenter />;
  }
  if (isError) {
    return <Page500 />;
  }
  return (
    <>
      <Row className="mb-3">
        <Col md={12}>
          <Card>
            <Card.Header className="bg-didxl text-white">
              Price lists
            </Card.Header>
            <Card.Body>
              <PricelistTable
                data={data}
                tariff={tariff}
                setTariff={setTariff}
                setPricelistLocation={setPricelistLocation}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {tariff ? (
        <Row>
          <Col md={12}>
            <Card>
              <Card.Header className="bg-didxl text-white" />
              <Card.Body>
                <PricelistTableObject
                  paymentModel={paymentModel}
                  tariff={tariff}
                  location={pricelistLocation}
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      ) : null}
    </>
  );
};
